import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import AboutPreview from './components/AboutPreview';
import SchemaOrg from '@/components/base/SchemaOrg';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '狠狠爱——爱得深沉，爱得彻底',
  description:
    '「狠狠爱」是一个专注于深度情感探索的中文内容平台。无论是爱自己、爱家人还是爱伴侣，狠狠爱就是把最真实的情感毫无保留地释放。',
  url: 'https://henhenai.com/',
  inLanguage: 'zh-CN',
  isPartOf: {
    '@type': 'WebSite',
    name: '狠狠爱',
    url: 'https://henhenai.com/',
  },
};

export default function Home() {
  return (
    <>
      <SchemaOrg data={homeSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoryGrid />
        <LatestArticles />
        <AboutPreview />
      </main>
      <Footer />
    </>
  );
}